const TILTPARA_STATE_KEY = "__aniTiltparaState";

function isSectionActive(section) {
  return (
    section.classList.contains("is-inview") ||
    section.classList.contains("scrolled-active") ||
    section.classList.contains("is-dominant")
  );
}

function applySectionTilt(section) {
  const prog = parseFloat(section.style.getPropertyValue("--ani-progress") || "0");
  const child = section.querySelector(".ani-section-child-tilt");
  if (!child) return;
  const start = parseFloat(child.dataset.aniTiltStart || "0");
  const end = parseFloat(child.dataset.aniTiltEnd || "0");
  const angle = start + (end - start) * prog;
  child.style.setProperty("--ani-tilt-angle", `${angle}deg`);
}

export function initTiltpara() {
  const previous = globalThis[TILTPARA_STATE_KEY];
  if (previous?.bound) return;
  if (typeof previous?.destroy === "function") {
    previous.destroy();
  }

  const sections = Array.from(
    document.querySelectorAll(".ani-section-tiltpara[data-ani-progress]")
  );
  const activeSections = new Set();
  const observers = [];
  let rafId = null;

  const tick = () => {
    if (!activeSections.size) {
      rafId = null;
      return;
    }
    activeSections.forEach((section) => applySectionTilt(section));
    rafId = requestAnimationFrame(tick);
  };

  const ensureTicking = () => {
    if (rafId != null || !activeSections.size) return;
    rafId = requestAnimationFrame(tick);
  };

  const syncSectionActivity = (section) => {
    if (!section || !section.isConnected) {
      activeSections.delete(section);
      return;
    }
    if (isSectionActive(section)) {
      activeSections.add(section);
      ensureTicking();
    } else {
      activeSections.delete(section);
    }
  };

  sections.forEach((section) => {
    const observer = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type === "attributes" && m.attributeName === "class") {
          syncSectionActivity(section);
          break;
        }
      }
    });
    observer.observe(section, { attributes: true, attributeFilter: ["class"] });
    observers.push(observer);
    syncSectionActivity(section);
  });

  const onDominantChange = (event) => {
    const dominant = event?.detail?.section || null;
    if (dominant) syncSectionActivity(dominant);
  };

  document.addEventListener("ani:dominant-change", onDominantChange, true);

  const destroy = () => {
    document.removeEventListener("ani:dominant-change", onDominantChange, true);
    observers.forEach((observer) => {
      try { observer.disconnect(); } catch {}
    });
    observers.length = 0;
    activeSections.clear();
    if (rafId != null) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
  };

  globalThis[TILTPARA_STATE_KEY] = { bound: true, destroy };
}
